import NTopNBottom from '../../components/NTopNBottom'

import navColor from '../../assets/birthday2022/nav/color.jpg'
import navBg from '../../assets/birthday2022/nav/nav_bg.png'
import navBgFixed from '../../assets/birthday2022/nav/nav_bg_fixed.png'

import far1 from '../../assets/birthday2022/nav/far1.jpg'
import far1_active from '../../assets/birthday2022/nav/far1_active.png'
import far2 from '../../assets/birthday2022/nav/far2.png'
import far2_active from '../../assets/birthday2022/nav/far2_active.jpg'
import far3 from '../../assets/birthday2022/nav/far3.jpg'
import far3_active from '../../assets/birthday2022/nav/far3_active.jpg'
import son1 from '../../assets/birthday2022/nav/son1.jpg'
import son1_active from '../../assets/birthday2022/nav/son1_active.jpg'
import son2 from '../../assets/birthday2022/nav/son2.jpg'
import son2_active from '../../assets/birthday2022/nav/son2_active.jpg'
import son3 from '../../assets/birthday2022/nav/son3.jpg'
import son3_active from '../../assets/birthday2022/nav/son3_active.jpg'
import son4 from '../../assets/birthday2022/nav/son4.jpg'
import son4_active from '../../assets/birthday2022/nav/son4_active.jpg'
import son5 from '../../assets/birthday2022/nav/son5.jpg'
import son5_active from '../../assets/birthday2022/nav/son5_active.jpg'
import son6 from '../../assets/birthday2022/nav/son6.jpg'
import son6_active from '../../assets/birthday2022/nav/son6_active.jpg'
import son7 from '../../assets/birthday2022/nav/son7.jpg'
import son7_active from '../../assets/birthday2022/nav/son7_active.jpg'
import son8 from '../../assets/birthday2022/nav/son8.jpg'
import son8_active from '../../assets/birthday2022/nav/son8_active.jpg'
import son9 from '../../assets/birthday2022/nav/son9.jpg'
import son9_active from '../../assets/birthday2022/nav/son9_active.jpg'
import son10 from '../../assets/birthday2022/nav/son10.jpg'
import son10_active from '../../assets/birthday2022/nav/son10_active.jpg'
import son11 from '../../assets/birthday2022/nav/son11.jpg'
import son11_active from '../../assets/birthday2022/nav/son11_active.jpg'
import son12 from '../../assets/birthday2022/nav/son12.jpg'
import son12_active from '../../assets/birthday2022/nav/son12_active.jpg'
import son13 from '../../assets/birthday2022/nav/son13.jpg'
import son13_active from '../../assets/birthday2022/nav/son13_active.jpg'

import bannerImg from '../../assets/birthday2022/banner.jpg'

const IS_PROD = process.env.VUE_APP_ENV_MICRO === 'production'

import calcRemFn from '../calcRem'

// 需要手动修改proId
const top1_prod = IS_PROD ? '106968' : '106968'
const top2_prod = IS_PROD ? '106970' : '106970'
const top3_prod = IS_PROD ? '106969' : '106969'

const navCss = {
  navWrap: {
    minHeight: calcRemFn(175),
    backgroundImage: `url(${navColor})`,
  },
  navCtn: {
    height: calcRemFn(175),
    backgroundImage: `url(${navBg})`,
  },
  navCtnFixed: {
    height: calcRemFn(175),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    position: 'absolute',
    width: '100%',
    bottom: `${calcRemFn(44)}`,
    padding: `0 ${calcRemFn(66)}`,
    boxSizing: 'border-box'
  },
  topBtnBaseCss: {
    width: calcRemFn(60),
    height: calcRemFn(25),
  },
  bottomBtnLayout: {
    flexWrap: 'wrap',
    padding: `${calcRemFn(38)} ${calcRemFn(48)} ${calcRemFn(35)} ${calcRemFn(54)}`,
  },
  bottomBtnBaseCss: {
    width: calcRemFn(60),
    height: calcRemFn(25),
    padding: `0 ${calcRemFn(3)}`,
  },
  LineCss2: {
    width: '1px',
    height: calcRemFn(10),
    backgroundColor: '#2B2929'
  }
}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active,
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active,
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active,
      },
      {
        key: '_i4',
        show: true,
        img: son4,
        img_actived: son4_active,
        hideLine: true
      },
      {
        key: '_i5',
        show: true,
        img: son5,
        img_actived: son5_active,
      },
      {
        key: '_i6',
        show: true,
        img: son6,
        img_actived: son6_active,
      },
      {
        key: '_i7',
        show: true,
        img: son7,
        img_actived: son7_active,
      },
      {
        key: '_i8',
        show: true,
        img: son8,
        img_actived: son8_active,
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son9,
        img_actived: son9_active,
        style: {
          width: `${calcRemFn(90)}`,
          height: `${calcRemFn(18.5)}`,
          padding: `${calcRemFn(3)} ${calcRemFn(20)} ${calcRemFn(3)} ${calcRemFn(8)}`
        }
      },
      {
        key: '_i2',
        show: true,
        img: son10,
        img_actived: son10_active,
        hideLine: true,
        style: {
          width: `${calcRemFn(90)}`,
          height: `${calcRemFn(18.5)}`,
          padding: `${calcRemFn(3)} ${calcRemFn(8)} ${calcRemFn(3)} ${calcRemFn(20)}`
        }
      },
      {
        key: '_i3',
        show: true,
        img: son11,
        img_actived: son11_active,
        style: {
          width: `${calcRemFn(90)}`,
          height: `${calcRemFn(18.5)}`,
          padding: `${calcRemFn(3)} 0`
        }
      },
      {
        key: '_i4',
        show: true,
        img: son12,
        img_actived: son12_active,
        style: {
          width: `${calcRemFn(90)}`,
          height: `${calcRemFn(18.5)}`,
          padding: `${calcRemFn(3)} 0`
        }
      },
      {
        key: '_i5',
        show: true,
        img: son13,
        img_actived: son13_active,
        style: {
          width: `${calcRemFn(90)}`,
          height: `${calcRemFn(18.5)}`,
          padding: `${calcRemFn(3)} 0`
        }
      }
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active,
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active,
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active,
      },
      {
        key: '_i4',
        show: true,
        img: son4,
        img_actived: son4_active,
        hideLine: true
      },
      {
        key: '_i5',
        show: true,
        img: son5,
        img_actived: son5_active,
      },
      {
        key: '_i6',
        show: true,
        img: son6,
        img_actived: son6_active,
      },
      {
        key: '_i7',
        show: true,
        img: son7,
        img_actived: son7_active,
      },
      {
        key: '_i8',
        show: true,
        img: son8,
        img_actived: son8_active,
      }
    ]
  },
  showLine2: true
}

const pictureList = [
  {
    key: '1_1',
    picNum: 2,
    pid: top1_prod
  },
  {
    key: '1_2',
    picNum: 2,
    pid: top1_prod
  },
  {
    key: '1_3',
    picNum: 2,
    pid: top1_prod
  },
  {
    key: '1_4',
    picNum: 1,
    pid: top1_prod
  },
  {
    key: '1_5',
    picNum: 1,
    pid: top1_prod
  },
  {
    key: '1_6',
    picNum: 1,
    pid: top1_prod
  },
  {
    key: '1_7',
    picNum: 1,
    pid: top1_prod
  },
  {
    key: '1_8',
    picNum: 1,
    pid: top1_prod
  },
  {
    key: '2_1',
    picNum: 2,
    pid: top2_prod
  },
  {
    key: '2_2',
    picNum: 1,
    pid: top2_prod
  },
  {
    key: '2_3',
    picNum: 1,
    pid: top2_prod
  },
  {
    key: '2_4',
    picNum: 1,
    pid: top2_prod
  },
  {
    key: '2_5',
    picNum: 1,
    pid: top2_prod
  },
  {
    key: '3_1',
    picNum: 1,
    pid: top3_prod
  },
  {
    key: '3_2',
    picNum: 2,
    pid: top3_prod
  },
  {
    key: '3_3',
    picNum: 2,
    pid: top3_prod
  },
  {
    key: '3_4',
    picNum: 1,
    pid: top3_prod
  },
  {
    key: '3_5',
    picNum: 1,
    pid: top3_prod
  },
  {
    key: '3_6',
    picNum: 1,
    pid: top3_prod
  },
  {
    key: '3_7',
    picNum: 1,
    pid: top3_prod
  },
  {
    key: '3_8',
    picNum: 1,
    pid: top3_prod
  }
]
function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/birthday2022/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'blue',
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

pictures.unshift({
  son: [
    require('../../assets/birthday2022/ctn/1_0_1.jpg')
  ],
})

const topDiff = {
  firstSon: '_i1',
}

export default {
  title: '生日照',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
